import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Image from 'app/components/layouts/Image';
import { useTranslation } from 'next-i18next';
import { Listen } from 'types/listen';
import first from 'lodash/first';
import Link from 'next/link';

const List = ({ listens, code }) => {
  code = code == 'en' ? 'vi' : code;
  const { t } = useTranslation();

  return (
    (listens || []).map((listen: Listen) => {
      return (
        <div className="mb-3 wrap-box-content" key={listen.slug}>
          <Link href={`/listening/${listen.slug}`}>
            <div className="d-flex ml-2">
              <Image
                width="50"
                height="50"
                className="image-listen mr-3 my-auto"
                alt={listen.title}
                src={`/images/commons/listening.webp`}
              />
              <div className="overflow-hidden">
                <div className="wrap-box-title text-left">{listen.title}</div>
                <small className="float-left">{first(listen?.translates)[code]}</small>
              </div>
              {listen?.is_activity && (
                <div className="ml-auto p-1 mt-2">
                  <FontAwesomeIcon className="text-success pr-1" icon={faCheck} />
                  <span className="mr-2 display-none-mobile">
                    {t('listening.learned')}
                  </span>
                </div>
              )}
            </div>
          </Link>
        </div>
      )
    })
  )
}

export default List;
